import { render } from "./PublisherPage.vue?vue&type=template&id=0d55dd9a"
import script from "./PublisherPage.vue?vue&type=script&lang=js"
export * from "./PublisherPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__